import { Session } from "@equiem/web-ng-lib";
import { NextPage } from "next";
import { useRouter } from "next/router";
import React from "react";
import { ContentNotAvailable } from "../../../components/ContentNotAvailable";
import { GeneralLayout } from "../../../components/layout/GeneralLayout";
import {
  ShareableContent,
  ShareableRedirect,
} from "../../../components/shareableContent";
import { withAppContexts } from "../../../contexts/withAppContexts";

export const Page: NextPage = ({}) => {
  const router = useRouter();
  const { id } = router.query;

  if (typeof id !== "string") {
    return <ContentNotAvailable />;
  }

  return (
    <Session.Consumer>
      {(s) =>
        s.authenticated ? (
          <GeneralLayout personalized>
            <ShareableRedirect id={id} />
          </GeneralLayout>
        ) : (
          <GeneralLayout hideBurgerMenu noMargin>
            <ShareableContent id={id} />
          </GeneralLayout>
        )
      }
    </Session.Consumer>
  );
};

export default withAppContexts(Page, {
  requireAuth: false,
  skipMetrics: true,
});
